export const GOVGR_WIDTH_CONTAINER = "govgr-width-container";
export const GOVGR_MAIN_WRAPPER = "govgr-main-wrapper";
export const LOGIN_DEFAULT_LABEL = "Login";
export const GOVGR_GRID_COLUMN_TWO_THIRDS = "govgr-grid-column-two-thirds";
export const GOVGR_HEADING_XL = "govgr-heading-xl";
export const GOVGR_BODY = "govgr-body";
